const HTTP_URL_PATTERN = /^https?:\/\//i;

export function isUrlLike(value?: string) {
  return Boolean(value && HTTP_URL_PATTERN.test(value));
}

export function getTwilioEnvironment() {
  const environment = process.env.REACT_APP_TWILIO_ENVIRONMENT;
  return isUrlLike(environment) ? undefined : environment;
}

export function getTokenEndpoint() {
  if (process.env.REACT_APP_TOKEN_ENDPOINT) {
    return process.env.REACT_APP_TOKEN_ENDPOINT;
  }

  if (isUrlLike(process.env.REACT_APP_TWILIO_ENVIRONMENT)) {
    return process.env.REACT_APP_TWILIO_ENVIRONMENT!;
  }

  return '/token';
}

export function getRecordingRulesEndpoint() {
  return process.env.REACT_APP_RECORDING_RULES_ENDPOINT || '/recordingrules';
}
